import { Input } from 'antd'
import { UIChatItem } from '../../../types'

type Props = {
  item: UIChatItem
  onChange: (content: string) => void
}

export const ContentInput = ({ item, onChange }: Props) => {
  const handleChange = (content: string) => {
    onChange(content)
  }

  return (
    <Input.TextArea
      defaultValue={item.content}
      autoSize={{ minRows: 1, maxRows: 20 }}
      onChange={event => handleChange(event.target.value)}
    />
  )
}
